export const image = {
  marginTop: 20,
  marginBottom: 10
};
export const colPadding = { paddingBottom: 30 };
export const imageWidth = { width: 450, maxWidth: 500 };
